/* =========================================================
   Product Card — 100% Dynamic Quick View Engine
   -----------------------------------------------------------
   - 100% Dynamic: Zero hardcoded product text, images, or SKUs
   - Fetches live product data from Shopify /products/${handle}.js
   - Dynamically renders product images, title, price, discount %,
     SKU, categories, variants, quantity, Add To Bag, and Buy Now
   - Live variant switching (updates image, price, discount, SKU, stock)
   - Live AJAX cart addition (/cart/add.js) & direct checkout
   ========================================================= */

(function () {
  var modalOverlay = null;
  var modalBody = null;
  var lastFocusedEl = null;

  // Currency Formatter (respects Shopify store settings or falls back cleanly)
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var format = Shopify.money_format || '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    var num = (cents / 100).toFixed(2);
    return '$' + num;
  }

  // Build the modal DOM lazily once
  function buildModal() {
    if (modalOverlay) return;

    modalOverlay = document.createElement('div');
    modalOverlay.className = 'qv-modal-overlay';
    modalOverlay.setAttribute('role', 'dialog');
    modalOverlay.setAttribute('aria-modal', 'true');

    var modal = document.createElement('div');
    modal.className = 'qv-modal';

    // Floating Circular Close Button with explicit stroke and dimensions
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'qv-modal-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:16px!important;height:16px!important;display:block!important;stroke:#111827!important;">' +
      '<path d="M12 4L4 12M4 4L12 12" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="stroke:#111827!important;stroke-width:2px!important;"></path>' +
      '</svg>';
    closeBtn.addEventListener('click', closeModal);

    modalBody = document.createElement('div');
    modalBody.className = 'qv-modal-body';

    modal.appendChild(closeBtn);
    modal.appendChild(modalBody);
    modalOverlay.appendChild(modal);
    document.body.appendChild(modalOverlay);

    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalOverlay.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function openModal() {
    buildModal();
    lastFocusedEl = document.activeElement;
    modalOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modalOverlay) return;
    modalOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
      lastFocusedEl.focus();
    }
  }

  function showLoading() {
    modalBody.innerHTML =
      '<div class="qv-modal-loading"><div class="qv-modal-spinner"></div></div>';
  }

  function showError(msg) {
    modalBody.innerHTML =
      '<div class="qv-modal-error">' +
      (msg || 'Sorry, this product could not be loaded. Please open the product page directly.') +
      '</div>';
  }

  // 100% DYNAMIC PRODUCT RENDERING
  function renderProductJSON(product, initialVariantId) {
    if (!product) {
      showError();
      return;
    }

    // Determine initial variant
    var selectedVariant = null;
    if (product.variants && product.variants.length > 0) {
      if (initialVariantId) {
        selectedVariant = product.variants.find(function (v) {
          return String(v.id) === String(initialVariantId);
        });
      }
      if (!selectedVariant) {
        selectedVariant = product.variants.find(function (v) {
          return v.available;
        }) || product.variants[0];
      }
    }

    // Dynamic Prices & Discount
    var price = selectedVariant ? selectedVariant.price : product.price;
    var comparePrice = selectedVariant ? selectedVariant.compare_at_price : product.compare_at_price;
    var hasDiscount = comparePrice && Number(comparePrice) > Number(price);
    var discountPercent = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;

    // Dynamic SKU
    var sku = (selectedVariant && selectedVariant.sku) ? selectedVariant.sku : '';

    // Dynamic Categories / Type / Tags
    var categoryItems = [];
    if (product.type && product.type.trim() !== '') {
      categoryItems.push(product.type.trim());
    }
    if (product.tags && Array.isArray(product.tags)) {
      product.tags.forEach(function (t) {
        if (t && categoryItems.indexOf(t.trim()) === -1 && categoryItems.length < 8) {
          categoryItems.push(t.trim());
        }
      });
    }

    // Dynamic Images Array
    var images = [];
    if (product.images && product.images.length > 0) {
      images = product.images.map(function(img) {
        return typeof img === 'string' ? img : (img.src || '');
      });
    } else if (product.featured_image) {
      var feat = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
      if (feat) images.push(feat);
    }

    var currentImgIndex = 0;
    if (selectedVariant && selectedVariant.featured_image && selectedVariant.featured_image.src) {
      var vImgIndex = images.indexOf(selectedVariant.featured_image.src);
      if (vImgIndex !== -1) currentImgIndex = vImgIndex;
    }
    var currentImgSrc = images[currentImgIndex] || '';

    // HTML Output
    var html = '<div class="qv-content-grid">';

    // 1. LEFT IMAGE COLUMN (Dynamic)
    html += '<div class="qv-image-col">';
    html += '  <div class="qv-main-img-wrap">';
    if (currentImgSrc) {
      html += '    <img src="' + currentImgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" class="qv-main-img js-qv-main-img">';
    } else {
      html += '    <div class="qv-no-image">No Image Available</div>';
    }
    html += '  </div>';

    if (images.length > 1) {
      html += '  <button type="button" class="qv-gallery-nav qv-gallery-prev js-qv-prev" aria-label="Previous image">&#10094;</button>';
      html += '  <button type="button" class="qv-gallery-nav qv-gallery-next js-qv-next" aria-label="Next image">&#10095;</button>';
    }
    html += '</div>';

    // 2. RIGHT DETAILS COLUMN (Dynamic)
    html += '<div class="qv-details-col">';
    html += '  <h2 class="qv-title">' + (product.title || '') + '</h2>';

    // Rating
    html += '  <div class="qv-rating-row">';
    html += '    <span class="qv-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>';
    html += '    <span class="qv-review-count">(' + (product.reviews_count || 0) + ')</span>';
    html += '  </div>';

    // Price Row
    html += '  <div class="qv-price-row">';
    if (hasDiscount) {
      html += '    <span class="qv-compare-price js-qv-compare-price">' + formatMoney(comparePrice) + '</span>';
      html += '    <span class="qv-price-divider js-qv-price-divider">|</span>';
    } else {
      html += '    <span class="qv-compare-price js-qv-compare-price" style="display:none;"></span>';
      html += '    <span class="qv-price-divider js-qv-price-divider" style="display:none;">|</span>';
    }
    html += '    <span class="qv-current-price js-qv-current-price">' + formatMoney(price) + '</span>';
    if (hasDiscount) {
      html += '    <span class="qv-discount-badge js-qv-discount-badge">-' + discountPercent + '%</span>';
    } else {
      html += '    <span class="qv-discount-badge js-qv-discount-badge" style="display:none;"></span>';
    }
    html += '  </div>';

    // Meta Details (SKU, Category)
    html += '  <div class="qv-meta-list">';
    if (sku) {
      html += '    <div class="qv-meta-row js-qv-sku-row">';
      html += '      <span class="qv-meta-label">SKU:</span>';
      html += '      <span class="qv-meta-val js-qv-sku">' + sku + '</span>';
      html += '    </div>';
    } else {
      html += '    <div class="qv-meta-row js-qv-sku-row" style="display:none;">';
      html += '      <span class="qv-meta-label">SKU:</span>';
      html += '      <span class="qv-meta-val js-qv-sku"></span>';
      html += '    </div>';
    }

    if (categoryItems.length > 0) {
      html += '    <div class="qv-meta-row">';
      html += '      <span class="qv-meta-label">CATEGORY:</span>';
      html += '      <span class="qv-meta-val">' + categoryItems.join(', ') + '</span>';
      html += '    </div>';
    }
    html += '  </div>';

    // Variants (If more than 1)
    if (product.variants && product.variants.length > 1) {
      html += '  <div class="qv-variants-wrap">';
      var optionName = (product.options && product.options[0]) ? (product.options[0].name || product.options[0]) : 'OPTIONS';
      html += '    <label class="qv-variant-label">' + String(optionName).toUpperCase() + ':</label>';
      html += '    <div class="qv-variant-options">';
      product.variants.forEach(function (v) {
        var isSelected = selectedVariant && String(v.id) === String(selectedVariant.id);
        var activeClass = isSelected ? 'is-active' : '';
        var vImg = (v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
        html += '      <button type="button" class="qv-variant-btn js-qv-variant-btn ' + activeClass + '"' +
          ' data-variant-id="' + v.id + '"' +
          ' data-price="' + v.price + '"' +
          ' data-compare-price="' + (v.compare_at_price || '') + '"' +
          ' data-sku="' + (v.sku || '') + '"' +
          ' data-available="' + v.available + '"' +
          ' data-image="' + vImg + '">' +
          v.title +
          '</button>';
      });
      html += '    </div>';
      html += '  </div>';
    }

    // Actions Box
    html += '  <div class="qv-actions-box">';
    html += '    <label class="qv-qty-label">QUANTITY:</label>';
    html += '    <div class="qv-row-actions">';
    
    // Pill Quantity
    html += '      <div class="qv-qty-pill">';
    html += '        <button type="button" class="qv-qty-btn js-qv-qty-minus" aria-label="Decrease">&minus;</button>';
    html += '        <input type="number" class="qv-qty-input js-qv-qty-val" value="1" min="1" aria-label="Quantity">';
    html += '        <button type="button" class="qv-qty-btn js-qv-qty-plus" aria-label="Increase">&plus;</button>';
    html += '      </div>';

    // Add To Bag
    var isAvailable = selectedVariant ? selectedVariant.available : true;
    var addBtnText = isAvailable ? 'Add To Bag' : 'Sold Out';
    var addBtnDisabled = isAvailable ? '' : 'disabled';
    html += '      <button type="button" class="qv-btn-add-bag js-qv-add-bag" ' + addBtnDisabled + '>' + addBtnText + '</button>';
    html += '    </div>';

    // Buy It Now
    html += '    <button type="button" class="qv-btn-buy-now js-qv-buy-now" ' + addBtnDisabled + '>Buy It Now</button>';
    html += '  </div>';

    html += '</div>';
    html += '</div>';

    modalBody.innerHTML = html;

    initModalEvents(product, images, currentImgIndex, selectedVariant ? selectedVariant.id : (product.variants && product.variants[0] ? product.variants[0].id : null));
  }

  // Interactive Events
  function initModalEvents(product, images, currentImgIndex, initialVariantId) {
    var activeVariantId = initialVariantId;
    var mainImg = modalBody.querySelector('.js-qv-main-img');

    // Gallery navigation
    var prevBtn = modalBody.querySelector('.js-qv-prev');
    var nextBtn = modalBody.querySelector('.js-qv-next');
    if (prevBtn && nextBtn && images.length > 1) {
      prevBtn.addEventListener('click', function () {
        currentImgIndex = (currentImgIndex - 1 + images.length) % images.length;
        if (mainImg) mainImg.src = images[currentImgIndex];
      });
      nextBtn.addEventListener('click', function () {
        currentImgIndex = (currentImgIndex + 1) % images.length;
        if (mainImg) mainImg.src = images[currentImgIndex];
      });
    }

    // Dynamic Variant Switch
    var variantBtns = modalBody.querySelectorAll('.js-qv-variant-btn');
    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        variantBtns.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        activeVariantId = this.dataset.variantId;
        var p = parseInt(this.dataset.price, 10);
        var cp = this.dataset.comparePrice ? parseInt(this.dataset.comparePrice, 10) : 0;
        var skuVal = this.dataset.sku;
        var isAvail = this.dataset.available === 'true';
        var imgUrl = this.dataset.image;

        var priceEl = modalBody.querySelector('.js-qv-current-price');
        var compareEl = modalBody.querySelector('.js-qv-compare-price');
        var dividerEl = modalBody.querySelector('.js-qv-price-divider');
        var badgeEl = modalBody.querySelector('.js-qv-discount-badge');

        if (priceEl) priceEl.textContent = formatMoney(p);
        if (cp && cp > p) {
          if (compareEl) {
            compareEl.textContent = formatMoney(cp);
            compareEl.style.display = 'inline';
          }
          if (dividerEl) dividerEl.style.display = 'inline';
          if (badgeEl) {
            var disc = Math.round(((cp - p) / cp) * 100);
            badgeEl.textContent = '-' + disc + '%';
            badgeEl.style.display = 'inline-flex';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (dividerEl) dividerEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }

        var skuRow = modalBody.querySelector('.js-qv-sku-row');
        var skuEl = modalBody.querySelector('.js-qv-sku');
        if (skuRow && skuEl) {
          if (skuVal && skuVal.trim() !== '') {
            skuEl.textContent = skuVal;
            skuRow.style.display = 'flex';
          } else {
            skuRow.style.display = 'none';
          }
        }

        if (imgUrl && mainImg) {
          mainImg.src = imgUrl;
          var imgIdx = images.indexOf(imgUrl);
          if (imgIdx !== -1) currentImgIndex = imgIdx;
        }

        var addBtn = modalBody.querySelector('.js-qv-add-bag');
        var buyBtn = modalBody.querySelector('.js-qv-buy-now');
        if (addBtn && buyBtn) {
          if (isAvail) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add To Bag';
            buyBtn.disabled = false;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
            buyBtn.disabled = true;
          }
        }
      });
    });

    // Quantity selector
    var qtyInput = modalBody.querySelector('.js-qv-qty-val');
    var minusBtn = modalBody.querySelector('.js-qv-qty-minus');
    var plusBtn = modalBody.querySelector('.js-qv-qty-plus');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var current = parseInt(qtyInput.value, 10) || 1;
        if (current > 1) qtyInput.value = current - 1;
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        var current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var val = parseInt(this.value, 10);
        if (isNaN(val) || val < 1) this.value = 1;
      });
    }

    // Add To Bag AJAX
    var addBagBtn = modalBody.querySelector('.js-qv-add-bag');
    if (addBagBtn) {
      addBagBtn.addEventListener('click', function () {
        if (!activeVariantId) return;
        var qty = parseInt(qtyInput.value, 10) || 1;
        addBagBtn.classList.add('is-loading');
        addBagBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: activeVariantId, quantity: qty })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function (cartItem) {
            addBagBtn.textContent = 'Added to Bag ✓';
            setTimeout(function () {
              addBagBtn.classList.remove('is-loading');
              addBagBtn.textContent = 'Add To Bag';
            }, 1800);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: cartItem } }));
          })
          .catch(function (err) {
            console.error('Cart add error:', err);
            addBagBtn.classList.remove('is-loading');
            addBagBtn.textContent = 'Add To Bag';
            alert('Could not add to bag. Please try again.');
          });
      });
    }

    // Buy It Now (Direct Checkout)
    var buyNowBtn = modalBody.querySelector('.js-qv-buy-now');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (!activeVariantId) return;
        var qty = parseInt(qtyInput.value, 10) || 1;
        buyNowBtn.textContent = 'Redirecting...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: activeVariantId, quantity: qty })
        })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            window.location.href = '/checkout';
          });
      });
    }
  }

  // Fetch controller
  function loadQuickView(handle, url, pid, triggerEl) {
    openModal();
    showLoading();

    if (handle) {
      var jsonUrl = '/products/' + handle + '.js';

      fetch(jsonUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('JSON fetch failed');
          return response.json();
        })
        .then(function (product) {
          renderProductJSON(product, pid);
          document.dispatchEvent(
            new CustomEvent('quickview:loaded', { detail: { container: modalBody, product: product } })
          );
        })
        .catch(function () {
          fallbackToHtml(url, triggerEl, pid);
        });
    } else {
      fallbackToHtml(url, triggerEl, pid);
    }
  }

  function fallbackToHtml(url, triggerEl, pid) {
    if (url && url !== '#') {
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTML fetch failed');
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var content =
            doc.querySelector('[data-quick-view-content]') ||
            doc.querySelector('.quick-view-content') ||
            doc.querySelector('main');

          if (content) {
            modalBody.innerHTML = content.innerHTML;
          } else {
            extractDynamicDataFromCard(triggerEl, pid);
          }
        })
        .catch(function () {
          extractDynamicDataFromCard(triggerEl, pid);
        });
    } else {
      extractDynamicDataFromCard(triggerEl, pid);
    }
  }

  // Extract real card data dynamically if offline or in static preview
  function extractDynamicDataFromCard(triggerEl, pid) {
    var card = triggerEl ? triggerEl.closest('.item-product, .gh-product-card') : null;
    if (!card) {
      showError();
      return;
    }

    var title = card.querySelector('.product__title, .gh-pcard-title');
    var titleText = title ? title.textContent.trim() : '';

    var imgEl = card.querySelector('.product__thumbnail, .gh-pcard-img');
    var imgSrc = imgEl ? (imgEl.getAttribute('data-src') || imgEl.src) : '';

    var priceEl = card.querySelector('.price-regular, .gh-pcard-price-current, .gh-pcard-price');
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    var priceClean = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
    var priceCents = Math.round(priceClean * 100);

    var compareEl = card.querySelector('.price-compare, .gh-pcard-price-compare');
    var compareText = compareEl ? compareEl.textContent.trim() : '';
    var compareClean = parseFloat(compareText.replace(/[^0-9.]/g, '')) || 0;
    var compareCents = Math.round(compareClean * 100);

    var typeEl = card.querySelector('.product__type, .gh-pcard-brand');
    var typeText = typeEl ? typeEl.textContent.trim() : '';

    var variantId = pid || triggerEl.getAttribute('data-pid') || card.getAttribute('data-product-id') || 'default-variant';

    renderProductJSON({
      title: titleText,
      price: priceCents,
      compare_at_price: compareCents > 0 ? compareCents : null,
      featured_image: imgSrc,
      images: imgSrc ? [imgSrc] : [],
      type: typeText,
      tags: [],
      variants: [{
        id: variantId,
        title: 'Default',
        price: priceCents,
        compare_at_price: compareCents > 0 ? compareCents : null,
        sku: '',
        available: true
      }]
    }, variantId);
  }

  // Quick View Button Click Listener
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.btnProductQuickview');
    if (!trigger) return;

    e.preventDefault();
    var handle = trigger.getAttribute('data-handle');
    var url = trigger.getAttribute('data-url') || trigger.getAttribute('data-product-url');
    var pid = trigger.getAttribute('data-pid');

    if (!handle && url) {
      var parts = url.split('?')[0].split('/');
      var possibleHandle = parts[parts.length - 1];
      if (possibleHandle && possibleHandle !== '#') {
        handle = possibleHandle;
      }
    }

    loadQuickView(handle, url, pid, trigger);
  });
})();